<template>
  <div>
    <div class="form-container ou-donation-form rtl" dir="rtl">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="המתנה שלך עושה את ההבדל במחנה דרור">
            <h3 style="color: black; text-transform: none; font-size: 16px; line-height: 1.5;">

            התרומה הנדיבה שלכם תסייע לסבסד את העלות של שלושה שבועות במחנה קיץ ללינה עבור בני נוער יהודים (מישראל ומהתפוצות), ותעניק להם שילוב ייחודי של חוויית קיץ מהנה, ציונות וחינוך יהודי.

            </h3>
            <FormRow inline class="forceShow">
              <LazyCurrencySelector :currencies="['USD', 'ILS']" class="forceShow"/>
            </FormRow>
            <AmountSelectorList @update:emittedDescription="handleUpdate" />
            <ErrorLabel field="amount" />
              <FormRow>
            <TransactionFee lang="he"/>
            </FormRow>
          </FormSection>
            <FormSection title="מידע נוסף">
            <br />
            <InHonorOf lang="he"/>
            <br />

            <FormRow inline style="margin-bottom: 0px" lang="he" class="datepicker">
              <FormLabel for="date" lang="he">
                Dedicate a specific date?
              </FormLabel>
            </FormRow>
            <FormRow>
              <input
                id="date"
                type="date"
                class="date-input"
                @change="setDailyDate(new Date($event.target.value))"
              />
            </FormRow>
            <br />
            <FormRow>
              <FormLabel lang="he" for="anonymousCheck">
                <input
                  type="checkbox"
                  id="anonymousCheck"
                  :checked="getValue('custom.anonymous') === 'yes'"
                  @click="setValue('custom.anonymous', $event.target.checked ? 'yes' : 'no')"
                /> Make my donation anonymous
              </FormLabel>
            </FormRow>
          </FormSection>
          <FormSection title="פרטים אישיים">
            <FormRow inline>
              <FormCol field="title" :flex="1" lang="he"/>
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/" lang="heb"/>
                  </FormRow>
          </FormSection>
          <FormSection title="כתובת" last>
            <DonorAddress />
          </FormSection>
          <FormRow inline>
            <FormCol field="card" :showLabel="false" lang="he"/>
          </FormRow>
          <PaymentButton showAmount btnText="המשך לתרומה" />
          <p class="note">
            <br />כל התרומות ניתנות לניכוי מס במלוא המידה המותרת בחוק.
          </p>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue, setValue, form } = usePaymentForm();
    const selectedDescription = ref<string | null>(null);

    const handleUpdate = (value: string | null) => {
      selectedDescription.value = value;
    };

    function setDailyDate(date: Date) {
      setValue(
        "custom.date",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
    }

    return {
      getValue,
      setValue,
      form,
      setDailyDate,
      handleUpdate,
      selectedDescription,
    };
  },
});
</script>



<style scoped lang="scss">
::v-deep .form-container.ou-donation-form{
    margin: 0px auto 20px;
    font-weight: 400;
    @media only screen and (min-width: 720px) {
      margin: 0px auto 40px;
    }
}
::v-deep label{
  font-size: 14px;
    color: #222;
    padding-top: 3px;
    padding-bottom: 3px;
    display: block;
    margin-bottom: 0px;
}
::v-deep hr {
    margin-bottom: 15px;
    margin-top: 0;
    border: 0;
    height: 0;
    border-top: 1px solid #efefef;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
.note {
  font-style: italic;
  line-height: 1.4;
  font-weight: bold;
  font-size: 14px;

  a {
    text-decoration: none;
  }
}

::v-deep .form-container{
  label[for="anonymousCheck"]:after {content:"הפוך את התרומה שלי לאנונימית";}
}
::v-deep .datepicker{
  label[for="date"]:after {content:"   להקדיש תאריך ספציפי?";}
}

::v-deep .styled-radio--ou-donation.styled-radio{
  padding: 0px;
}

::v-deep .styled-radio--ou-donation.styled-radio{
  padding: 0px;
     .amount_other__wrapper input[type=number] {
    position: relative;
    opacity: 1;
    cursor: pointer;
  }
}
</style>
